import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Iconify from '../../components/iconify';

export default function DataTableToolbar({ 
  fromDate, 
  toDate, 
  filterName, 
  onFromDateChange, 
  onToDateChange, 
  onFilterName,
}) {

  return (
    <Toolbar
      sx={{
        height: 80,
        display: 'flex',
        justifyContent: 'space-between',
        p: (theme) => theme.spacing(0, 1, 0, 3),
        flexWrap: 'wrap',
      }}
    >
      {/* Search Input */}
      <Stack direction="row" spacing={2} alignItems="center">
        <OutlinedInput
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          inputProps={{ style: { padding: 10 } }}
          startAdornment={
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          }
        />
      </Stack>

      {/* Date Filters */}
      <Stack direction="row" spacing={2} alignItems="center">
        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={onFromDateChange}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{ width: 200 }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={onToDateChange}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{ width: 200 }}
        />
      </Stack>
    </Toolbar>
  );
}

DataTableToolbar.propTypes = {
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  filterName: PropTypes.string,
  onFromDateChange: PropTypes.func,
  onToDateChange: PropTypes.func,
  onFilterName: PropTypes.func,
  onReset: PropTypes.func,
  onQuickSearch: PropTypes.func,
};